import { z } from 'zod';

/* Операции, которые не доехали до банка или кассы и исчерпали попытки.
 *
 * Пока такая строка лежит, деньги клиента заперты: холд не снят, возврат не сделан, чек не
 * пробит. Экран существует ровно затем, чтобы это было видно человеку, а не только в логах. */
export const stuckDeliverySchema = z.object({
  id: z.string(),
  /* Код события — для того, кто пойдёт искать строку в логах. */
  event_type: z.string(),
  /* Название для человека: «Возврат денег клиенту». */
  title: z.string(),
  order_id: z.string(),
  order_number: z.string().nullable(),
  occurred_at: z.string(),
  attempts: z.number(),
  last_error: z.string().nullable(),
  /* Сколько денег заперто этой строкой. `null` — операция не про деньги. */
  money_at_stake: z.string().nullable(),
  /* RELEASE — не вернулись клиенту, CAPTURE — не списались нам, REFUND — не возвращены после
     списания, RECEIPT — не пробит чек. */
  money_kind: z.string().nullable(),
  /* Ложь — у строки битый payload: повтор её не починит, чинит код. */
  retriable: z.boolean(),
});
export type StuckDelivery = z.infer<typeof stuckDeliverySchema>;

export const stuckDeliveriesSchema = z.object({
  total: z.number(),
  /* Итог по ВСЕМ застрявшим строкам, а не по показанной странице. */
  money_at_stake: z.string(),
  items: z.array(stuckDeliverySchema),
});
export type StuckDeliveries = z.infer<typeof stuckDeliveriesSchema>;

export const retryAllResultSchema = z.object({
  retried: z.number(),
});
export type RetryAllResult = z.infer<typeof retryAllResultSchema>;
